module.exports = __webpack_public_path__ + "c1f2b50bed050ae8bc7e48fe890fe425.pdf";